export const formatAmount = (amount: number): string => {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
  });

  return formatter.format(amount);
};

export const formatDateTime = (dateTime: number | string | Date, language = 'en') => {
  const formattedDateTime = new Intl.DateTimeFormat(language, {
    month: '2-digit',
    day: '2-digit',
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
  }).format(new Date(dateTime));

  return formattedDateTime;
};
